import { render, staticRenderFns } from "./HotelOrderItemize.vue?vue&type=template&id=5f7d96fb&scoped=true"
import script from "./HotelOrderItemize.vue?vue&type=script&lang=js"
export * from "./HotelOrderItemize.vue?vue&type=script&lang=js"
import style0 from "./HotelOrderItemize.vue?vue&type=style&index=0&id=5f7d96fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7d96fb",
  null
  
)

export default component.exports